// extracted by mini-css-extract-plugin
export var questioncard = "faq-module--questioncard--DN40o";
export var questioncardgroup = "faq-module--questioncardgroup--slYVf";